/**
 * Slate Mobile Navigation Menu
 *
 */
(function () {

    'use strict';

    /**
     * 'is_mobile' variable to determine if this is a mobile size.
     */
    var set_is_mobile, is_mobile = false;

    window.addEventListener('load', function () {
        var menuToggle = document.getElementById('menu-toggle');
        var mainMenuToggle = document.getElementById('main-menu-toggle');
        var subToggles = document.querySelectorAll('.submenu-toggle');

        (set_is_mobile = function () {
            if (window.getComputedStyle(menuToggle).display === "none") {
                is_mobile = false;
            } else {
                is_mobile = true;
            }
        })();
        
        // Function to close the menu
        function closeMenu(button) {
            var submenu = button.parentElement.querySelector('.menu__submenu');
            submenu.style.opacity = '0';
            submenu.style.transition = 'opacity .25s ease-in-out, visibility .25s ease-in-out';
            submenu.style.visibility = 'hidden';
            button.classList.remove('open');
            button.parentNode.classList.remove('open');
            button.parentNode.parentNode.classList.remove('open');
            button.setAttribute('aria-expanded', false);
        }

        /**
         * Toggle menu open/closed when clicking menu toggle
         */
        menuToggle.addEventListener('click', function () {
            this.classList.toggle('open');
            document.getElementById('menu').classList.toggle('open');
            document.querySelector('body').classList.toggle('opened-menu');

            if (this.classList.contains('open')) {
                this.setAttribute('aria-expanded', true);
            } else {
                this.setAttribute('aria-expanded', false);
            }

            // document.querySelector('.main-menu .menu').classList.remove('open');
            var toggles = document.querySelectorAll('.main-menu .submenu-toggle.open');

            toggles.forEach(element => {
                element.classList.remove('open');
            });
        });

        /**
         * Toggle sub-menu visibility
         */
        mainMenuToggle.addEventListener('click', function () {
            this.classList.remove('open');
            menuToggle.style.display = 'block';
            document.querySelector('.main-menu .menu').classList.remove('open');

            var toggles = document.querySelectorAll('.main-menu .submenu-toggle.open');

            toggles.forEach(element => {
                element.classList.remove('open');
                element.nextElementSibling.style.maxHeight = '0px';
            });
            
            var submenus = document.querySelectorAll('.menu__submenu');
            
            submenus.forEach(submenu => {
                if (submenu.style.overflow == 'visible') {
                    submenu.style.overflow = 'hidden';
                }
                submenu.classList.remove('open');
            });
            
            var menuItems = document.querySelectorAll('.menu__item');
            
            menuItems.forEach(menuItem => {
                menuItem.classList.remove('open');
            });
        });
        
        for (var i = 0; subToggles.length > i; i++) {
            var toggleButton = subToggles[i];

            toggleButton.addEventListener('click', function (event) {
                var submenu = toggleButton.parentElement.querySelector('.menu__submenu');
                
                if (this.classList.contains('open')) {
                    closeMenu(this);
                                        
                    // remove these hiding properties when mousing out, so it can be hovered again
                    this.addEventListener('mouseout', function() {
                        submenu.style.opacity = '';
                        submenu.style.transition = '';
                        submenu.style.visibility = '';
                    });
                } else {
                    this.classList.add('open');
                    this.parentNode.classList.add('open');
                    this.parentNode.parentNode.classList.add('open');
                    this.nextElementSibling.style.maxHeight = 'none';
                    this.setAttribute('aria-expanded', true);
                }
                
                if (this.parentNode.parentNode.classList.contains('menu__submenu')) {
                    if (this.parentNode.parentNode.style.overflow == 'visible') {
                        this.parentNode.parentNode.style.overflow = 'hidden';
                    } else {
                        this.parentNode.parentNode.style.overflow = 'visible';
                    }
                }

                document.getElementById('menu-toggle').style.display = 'none';
                document.getElementById('main-menu-toggle').classList.add('open');
                
                // Stop the event from bubbling up to the document
                event.stopPropagation();
                
                // Event listener for clicks anywhere else on the document
                document.addEventListener('click', function(event) {
                    // Check if the clicked element is NOT the submenu or the arrow button
                    if (!submenu.contains(event.target) && !toggleButton.contains(event.target)) {
                        closeMenu(toggleButton); // Close the menu if clicked outside
                        console.log('menu closed from document click');
                    }
                });
            });
        }

        window.addEventListener('resize', function () {
            if (this.window.innerWidth >= 992) {
                menuToggle.classList.remove('open');
                menuToggle.setAttribute('aria-expanded', false);
                document.getElementById('menu').classList.remove('open');
                document.querySelector('body').classList.remove('opened-menu');
                mainMenuToggle.classList.remove('open');
                document.querySelector('.main-menu .menu').classList.remove('open');
                
                var toggles = document.querySelectorAll('.main-menu .submenu-toggle.open');
    
                toggles.forEach(element => {
                    element.classList.remove('open');
                    element.nextElementSibling.style.maxHeight = '0px';
                });
                
                var submenus = document.querySelectorAll('.menu__submenu');
                
                submenus.forEach(submenu => {
                    if (submenu.style.overflow == 'visible') {
                        submenu.style.overflow = 'hidden';
                    }
                    submenu.classList.remove('open');
                });
                
                var menuItems = document.querySelectorAll('.menu__item');
                
                menuItems.forEach(menuItem => {
                    menuItem.classList.remove('open');
                });
            } else {                
                if (!mainMenuToggle.classList.contains('open')) {
                    menuToggle.style.display = 'block';
                }
            }
        });
    });
    
})();